import React from 'react'
import styled, { css } from 'styled-components'

const width = '17'
const height = '16'
const viewBox = '0 0 17 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#1E4F67"
      fillRule="evenodd"
      d="M13.323 11.158l2.91 2.911c.39.388.38 1.026-.007 1.414l-.034.034a1.008 1.008 0 0 1-1.414.008l-2.926-2.927A7.312 7.312 0 0 1 7.526 14C3.546 14 .321 10.866.321 7s3.226-7 7.205-7c3.98 0 7.205 3.134 7.205 7a6.838 6.838 0 0 1-1.408 4.158zM7.526 12c2.842 0 5.146-2.239 5.146-5s-2.304-5-5.146-5S2.38 4.239 2.38 7s2.304 5 5.146 5z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconMagnifyingGlass'
})
